<template>
  <v-card>
    <!-- <div> -->
    <v-card-title>
      <v-layout row wrap>
        <v-flex xs12>
          <h3 :class="titleClass || 'headline font-weight-bold primary--text'">
            {{ title }}
          </h3>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="allowSearch === true"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
            <v-tooltip slot="append-outer" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="!columnFilteringEnabled && hasColumnFilters"
                  slot="activator"
                  icon
                  class="ma-0"
                  @click="
                    columnFilteringEnabled = !columnFilteringEnabled
                    refreshAllColumnsFilterData()
                  "
                  ><v-icon>filter_list</v-icon>
                </v-btn>
              </template>
              <span>Filter</span>
            </v-tooltip>
            <v-tooltip slot="append-outer" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="columnFilteringEnabled"
                  slot="activator"
                  icon
                  class="ma-0"
                  @click="closeFilterHeader"
                  ><v-icon>clear</v-icon>
                </v-btn>
              </template>
              <span>Close filter</span>
            </v-tooltip>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="rows"
        :select-all="selectAll"
        :item-key="rowItemKey"
        :rows-per-page-items="rowsPerPageItemsFinal"
        show-select
        :pagination.sync="pagination"
        :loading="loading"
        :total-items="totalItems"
        rows-per-page-text="Rânduri pe pagină"
      >
        <template v-slot:headers="props">
          <tr>
            <th v-if="selectAll"></th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.class || '',
                header.value === pagination.sortBy ? 'active' : ''
              ]"
              :style="`min-width: ${header.width}`"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
          <tr v-if="columnFilteringEnabled" :key="columnsFiltersDataUpdates">
            <td v-for="(header, index) in headers" :key="header.value">
              <div class="selectSubheader">
                <template v-if="header.dateRange">
                  <v-daterange
                    :value="columnsFilters[header.value]"
                    format="YYYY-MM-DD"
                    no-presets
                    no-title
                    scrollable
                    @input="
                      (range) => {
                        if (columnsFilters[header.value] == null) {
                          columnsFilters[header.value] = {}
                        }
                        columnsFilters[header.value].type = 'date-range'
                        columnsFilters[header.value].start = range.start
                        columnsFilters[header.value].end = range.end
                        columnsFiltersUpdates++
                        debounceRefreshData()
                      }
                    "
                  ></v-daterange>
                </template>

                <!-- :key="header.updates" -->
                <!-- :loading="header.loading" -->
                <!--  -->
                <!-- :menu-props.sync="columnsFiltersMenu[header.value]" -->
                <v-autocomplete
                  v-if="header.selectable"
                  :ref="`header-${header.value}`"
                  v-model="columnsFilters[header.value]"
                  :items="header.filterOptions"
                  :loading="columnsFiltersDataLoading[header.value]"
                  :readonly="
                    header.filterOptions == null ||
                      header.filterOptions.length === 0 ||
                      columnsFiltersDataLoading[header.value]
                  "
                  @focus="
                    if (
                      header.filterOptions == null ||
                      header.filterOptions.length === 0
                    ) {
                      refreshColumnFilterData(index)
                      return
                    }
                  "
                >
                  <template v-if="header.selectable" slot="append">
                    <v-icon>expand_more</v-icon>
                    <v-tooltip slot="append-outer" top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          slot="append-outer"
                          icon
                          class="ma-0"
                          v-on="on"
                          @click.stop="emptySelect(header.value)"
                        >
                          <v-icon
                            :style="{
                              fontSize: 1.2 + 'em'
                            }"
                            >clear</v-icon
                          >
                        </v-btn></template
                      >
                      <span>Clear</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr
            :class="
              coloring ? getConditionClass(coloring.rowLevel, props.item) : ''
            "
            @click="$emit('rowClick', props.item)"
          >
            <td v-if="selectAll">
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td
              v-for="(header, index) in headers"
              :key="index"
              class="td"
              :class="
                coloring.cellLevel !== undefined
                  ? 'header.textClass' +
                    getConditionClass(
                      coloring.cellLevel[header.value],
                      props.item[header.value]
                    )
                  : 'header.textClass'
              "
              @click="$emit('rowClick', props.item)"
            >
              {{ props.item[header.value] }}
            </td>
            <td v-if="hasAttachments">
              <v-btn icon>
                <v-icon
                  align-end
                  color="#808080"
                  @click.stop="$emit('showAttachment', props.item)"
                  >attachment</v-icon
                >
              </v-btn>
            </td>
            <td v-if="showDeleteBtn === false">
              <v-btn icon @click="$emit('deleteClicked', props.item)">
                <v-icon align-end color="#808080">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-btn v-if="showRefreshBtn" color="#541bc5" @click="refreshData"
      >Reîncarcă</v-btn
    >
    <!-- </div> -->
  </v-card>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
//import axios from 'axios';
import Vue from 'vue'
import ApiService from '../APIService'
var _ = require('lodash')

export default {
  name: 'QueryTableWidget',
  props: {
    value: {
      // uses set as v-model
      type: Array,
      default: () => []
    },
    queryId: {
      type: String,
      required: true
    },
    showRefreshBtn: {
      type: Boolean,
      default: false
    },
    showDeleteBtn: {
      type: Boolean,
      default: false
    },
    hardFilters: {
      type: Object,
      default: null
    },
    allowSearch: {
      type: Boolean,
      default: true
    },
    // nu pare sa ia in calcul aceste valori default trebuie sa le specificam si de mana
    rowsPerPageItems: {
      type: Array,
      default: () => [
        10,
        25,
        50,
        100,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ]
    },
    rowsPerPage: {
      type: Number,
      default: 10
    },
    defaultSort: {
      type: Object,
      default: null
    },
    selectAll: {
      type: Boolean,
      default: false
    },
    rowItemKey: {
      type: String,
      default: '_id'
    },
    csvExport: {
      type: Boolean,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    titleClass: {
      type: String,
      default: 'headline font-weight-bold primary--text'
    },
    dateToday: {
      type: [Date, String],
      default: null
    },
    formSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selected: [],
      headers: [],
      search: '',
      rows: [],
      pagination: !this.defaultSort
        ? {
            rowsPerPage: this.rowsPerPage || 10
          }
        : {
            rowsPerPage: this.rowsPerPage || 10, //needs fixing in
            sortBy: this.defaultSort.sortBy,
            descending: this.defaultSort.sortDesc
          },
      loading: false,
      totalItems: 0,
      columnsFilters: {},
      columnFilteringEnabled: false,
      dateInterval: {},
      columnsFiltersDataUpdates: 0,
      columnsFiltersDataLoading: {},
      columnsFiltersMenu: {}
    }
  },
  computed: {
    hasAttachments() {
      let hasAttachments = false
      if (this.formSpecs != null) {
        if (this.formSpecs.hasAttachments) hasAttachments = true
      }
      return hasAttachments
    },
    // functia returneaza un obiect:
    // {
    //    rowLevel: function {return coloring-class},
    //    cellLevel: {
    //                  cell: function {return coloring-class}
    //                }
    // }
    coloring() {
      let coloring = {}
      // eslint-disable-next-line no-unused-vars
      let that = this
      // parse function and class for colouring rows and cells by condition
      if (this.formSpecs != null && this.formSpecs.conditions != null) {
        Object.keys(this.formSpecs.conditions).forEach((key) => {
          if (key == 'cellLevel') {
            coloring[key] = {}
            Object.keys(this.formSpecs.conditions[key]).forEach((h) => {
              coloring[key][h] = eval(this.formSpecs.conditions[key][h].f)
            }) // o singura conditie pe randuri
          } else if (key == 'rowLevel') {
            coloring[key] = eval(this.formSpecs.conditions[key].f)
          }
        })
      }
      return coloring
    },
    rowsPerPageItemsFinal() {
      //
      if (this.rowsPerPageItems == null) {
        return [
          10,
          25,
          50,
          100,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
        ]
      }
      const arr = JSON.parse(JSON.stringify(this.rowsPerPageItems))
      if (arr.includes(-1)) {
        const allElementsIndex = arr.indexOf(-1)
        arr.splice(allElementsIndex, 1, {
          text: '$vuetify.dataIterator.rowsPerPageAll',
          value: -1
        })
      }

      return arr
    },
    hasColumnFilters() {
      let filtersExist = false
      this.headers.forEach((h) => {
        if (h.selectable != null) {
          filtersExist = true
        }
      })
      return filtersExist
    }
  },
  watch: {
    pagination: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceRefreshData()
      }
    },
    columnsFilters: {
      deep: true,
      immediate: true,
      handler() {
        if (
          this.columnsFilters != null &&
          Object.keys(this.columnsFilters).length > 0
        ) {
          this.debounceRefreshData()
        }
      }
    },
    search() {
      this.debounceRefreshData()
    },
    selected(val) {
      var selectedKeys = new Set([])
      if (val != null) {
        val.forEach((element) => {
          selectedKeys.add(element[this.rowItemKey])
        })
      }
      this.$emit('input', Array.from(selectedKeys))
    }
  },
  created() {
    this.getQueryInfo().then(() => this.refreshData())
    // load query metadata and data
  },
  methods: {
    filterDateByInterval() {
      console.log(
        'From ' + this.dateInterval.start + ' to ' + this.dateInterval.end
      )
    },
    // function returns string = vuetify class for colouring the row based on dynamic condition
    getConditionClass(funct, item) {
      if (funct === undefined) return ''
      else {
        return funct(item)
      }
    },
    closeFilterHeader() {
      this.columnFilteringEnabled = !this.columnFilteringEnabled
      this.headers.forEach((h) => {
        if (h.hasOwnProperty('filterOptions')) {
          this.emptySelect(h.value)
        }
      })
    },
    findHeaderByKey(key, headers) {
      for (let h of headers) {
        if (h.value == key) {
          return h.text
        }
      }
      return null
    },
    getTableContentForExport(pdf) {
      if (pdf === undefined || pdf == null) pdf = false

      let content = []
      const clonedItems = Object.entries(this.rows)
      const parsedItems = []
      var headerSet = []

      // put  headers
      this.headers.forEach((h) => {
        headerSet.push(h.value)
      })
      // put  data
      clonedItems.forEach((item) => {
        const newItem = {}
        for (let key of headerSet) {
          const k = this.findHeaderByKey(key, this.headers)
          if (k != null) {
            newItem[k] = item[1][key]
          }
        }
        parsedItems.push(newItem)
      })

      if (pdf) {
        let pdfBody = []
        for (let i = 0; i < Object.keys(parsedItems).length; i++) {
          pdfBody.push(Object.values(parsedItems[i]))
        }
        headerSet = Object.keys(parsedItems[0])
        return [headerSet, pdfBody]
      }

      // add content with separator for csv
      content += [
        Object.keys(parsedItems[0]).join(';'),
        ...parsedItems.map((item) => Object.values(item).join(';'))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      return content
    },
    exportPDF() {
      let doc = new jsPDF('landscape')
      let result = this.getTableContentForExport(true)
      let pdfHead = result[0]
      let pdfBody = result[1]

      doc.autoTable({
        head: [pdfHead],
        body: pdfBody,
        headStyles: {
          minCellWidth: 20
        },
        didParseCell: ({ cell }) => {
          if (cell === undefined) {
            return
          }
          const hasCustomWidth = typeof cell.styles.cellWidth === 'number'

          if (hasCustomWidth || cell.raw == null || cell.colSpan > 1) {
            return
          }
          let text

          if (cell.raw instanceof Node) {
            text = cell.raw.innerText
          } else {
            if (typeof cell.raw == 'object') {
              // not implemented yet
              // when a cell contains other cells (colSpan)
              return
            } else {
              text = '' + cell.raw
            }
          }
          if (text.includes(' - ')) {
            text = text.split(' - ').join('- ')
          } else if (text.includes('-')) {
            text = text.split('-').join('- ')
          }
          if (text.includes(';') && !text.includes('; ')) {
            text = text.split(';').join('; ')
          }
          // split cell string by spaces
          cell.text = text.split(' ')
        }
      })
      doc.save('Export.pdf')
    },
    exportCSV() {
      let filename = 'Export'
      let csvContent = '\uFEFF' //pentru afisarea corecta a diacriticelor, se forteaza excelul sa deschida fisierul cu utf-8 (by default deschide cu ansi)
      csvContent += this.getTableContentForExport()

      const data = 'data:text/csv;charset=utf-8,' + encodeURI(csvContent)
      const link = document.createElement('a')

      link.setAttribute('href', data)
      link.setAttribute('download', `${filename}.csv`)
      link.click()
    },
    debounceRefreshData: _.debounce(function() {
      this.refreshData()
    }, 500),
    async refreshData() {
      if (this.loading) return
      console.log('Refreshing data')
      this.loading = true
      let filter = this.search !== '' ? this.search : null
      //fetch the query data
      await ApiService.getQueryDataWithFilters({
        queryId: this.queryId,
        hardFilters: this.hardFilters,
        pageIndex:
          this.pagination.rowsPerPage === -1 ? null : this.pagination.page - 1,
        pageSize:
          this.pagination.rowsPerPage === -1
            ? null
            : this.pagination.rowsPerPage,
        filter: filter != null ? filter.toLowerCase() : null,
        descending: this.pagination.descending,
        sortBy: this.pagination.sortBy,
        columnsFilters: this.columnsFilters
      })
        .then((response) => {
          this.totalItems = parseInt(response.headers['total-items'])
          this.rows = response.data
        })
        .catch((ex) => {
          console.log(
            'Could not fetch data from query: ' + ex.response.statusText
          )
          this.rows = []
        })
        .finally(() => {
          this.loading = false
        })
      if (this.value != null) {
        this.value.forEach((key) => {
          if (this.rows != null) {
            this.rows.forEach((row) => {
              if (row[this.rowItemKey] === key) {
                this.selected.push(row)
              }
            })
          }
        })
      }
      this.prevPage =
        this.pagination.page != undefined ? this.pagination.page : this.prevPage
    },
    refreshAllColumnsFilterData() {
      this.headers.forEach((header, index) => {
        this.refreshColumnFilterData(index)
      })
    },
    refreshColumnFilterData(headerIndex) {
      let header = this.headers[headerIndex]
      console.log(this.headers)
      if (header.value == null) {
        return
      }
      if (header.selectable == null || header.selectable === false) {
        return
      }
      if (header.loadingData) {
        return
      }

      console.log('ref')

      this.columnsFiltersDataLoading[header.value] = true

      header.loadingData = true
      console.log('Refreshing column filter data for : ' + header.value)
      ApiService.getQueryDataWithFilters({ queryId: header.selectable })
        .then((res) => {
          if (res.data != null && Array.isArray(res.data)) {
            const data = res.data
              .filter((el) => el._id != null && el._id !== '')
              .map((el) => el._id)
            Vue.set(header, 'filterOptions', data)
          }
          console.log(
            '%cRefreshed column filter data for : ' + header.value,
            'color: #0f0'
          )
          console.log(header.filterOptions)
        })
        .catch((ex) => {
          console.log(
            '%cCould not fetch column filters data for: ' + header.value,
            'color: #f00'
          )
          console.log(ex)
        })
        .finally(() => {
          header.loadingData = false
          header.updates++ // bag pula in mortii lui ca nu functioneaza
          this.columnsFiltersDataLoading[header.value] = false

          this.columnsFiltersDataUpdates++

          this.columnsFiltersMenu[header.value].value = true
        })
    },
    async getQueryInfo() {
      await ApiService.getQuery(this.queryId).then(async (response) => {
        if (response.status !== 200) {
          console.log('Could not fetch query headers : ' + response.statusText)
          this.headers = []
          this.filters = []
          return
        }

        this.headers = response.data.headers
        //if (this.formSpecs.hasAttachments) this.headers.unshift('')
        // this.headers.push({ text: 'Actions', sortable: false })
        this.filters =
          response.data.filters !== null ? response.data.filters : []
      })
      this.headers.forEach((header) => {
        if (header.selectable != null) {
          header.updates = 0
          header.filterOptions = []
          header.loadingData = false
          this.columnsFiltersDataLoading[header.value] = false
          this.columnsFiltersMenu[header.value] = {
            value: false
          }
        }
      })
    },
    emptySelect(headerValue) {
      Vue.delete(this.columnsFilters, headerValue)
      this.refreshData()
    },
    changeSort(column) {
      if (this.pagination.sortBy == null || this.pagination.sortBy !== column) {
        this.pagination.sortBy = column
        this.pagination.descending = false
      } else {
        if (this.pagination.descending) {
          this.pagination.sortBy = null
        } else {
          this.pagination.descending = !this.pagination.descending
        }
      }
    }
  }
}
</script>

<style>
table th {
  padding: 0 5px;
}

.export-button {
  border: 1px solid black;
  margin: 0 1em;
}
</style>
